import { Modal, Progress, Table } from 'antd';
import { CSVLink } from 'react-csv';
import styled from 'styled-components';

export const StyledImg = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
`;

export const Title = styled.div`
  font-size: 14px;
  color: #748aa1;
  padding-bottom: 4px;
`;

export const Description = styled.div`
  font-size: 13.2px;
  color: #b8bec5;
  padding-bottom: 2px;
`;

export const StyledLink = styled.a`
  font-size: 12px;
`;

export const StyledCSVLink = styled(CSVLink)`
  font-size: 12px;
  float: ${({ float }) => float || 'left'};
`;

export const Label = styled.div`
  font-size: 12px;
  color: #b8bec5;
  margin-top: 32px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
`;

export const UploadText = styled.p`
  font-size: 15px;
`;

export const UploadHint = styled.p`
  font-size: 13px;
  color: #748aa1;
`;

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    .ant-modal-header {
      border-radius: 12px;
    }
    .ant-modal-footer {
      padding: 16px 16px;
    }
  }
`;

export const StyledProgress = styled(Progress)`
  margin: 8px 0px;
`;

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  width: 408px;
`;

export const ModalHeader = styled.div`
  color: #31394d;
  font-size: 14px;
  font-weight: 600;
  margin: 16px 0px 8px;
  text-align: center;
`;

export const ModalDesc = styled.div`
  font-size: 11px;
  color: #748aa1;
  text-align: center;
`;

export const ErrorHeader = styled(ModalHeader)`
  color: red;
`;

export const ErrorDesc = styled(ModalDesc)`
  color: red;
  max-height: 64px;
  overflow: hidden;
`;

export const ErrorDetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  background: #eef4fa;
  align-items: center;
  width: 304px;
  margin-bottom: 8px;
  padding: 8px;
  font-size: 12px;

  div {
    text-align: center;
  }

  svg {
    color: #2b73e0;
    width: 20px;
    height: 20px;
    margin: 0 20px 0 8px;
  }
`;

export const TableContainer = styled.div`
  width: 536px;
  margin-top: 8px;
`;

export const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
  }
  .ant-table-thead {
    tr {
      .ant-table-cell {
        padding: 0.5rem;
        border-top: 1px solid #d5dee7;
        border-bottom: 1px solid #d5dee7;
        border-left: 1px solid #d5dee7;
        background: #eef4fa;
        vertical-align: top;
        font-size: 10px;
        font-weight: 500;
        font-style: normal;
        line-height: 12px;
        color: #556069;
        &:last-of-type {
          border-right: 1px solid #d5dee7;
        }
      }
    }
  }
  .ant-table-tbody {
    tr {
      .ant-table-cell {
        padding: 0.75rem 0.5rem;
        font-style: normal;
        font-weight: normal;
        font-size: 11px;
        line-height: 12px;
        color: #556069;
        strong {
          font-weight: 500;
        }
      }

      &:last-of-type {
        td {
          border-bottom: 1px solid #d5dee7;
        }
      }
    }
  }
  .ant-pagination {
    .ant-pagination-item {
      color: #31394d;
      border-radius: 4px;
    }
    .ant-pagination-item-active {
      color: #21b4bd;
      border-color: #21b4bd;
    }

    .ant-pagination-total-text {
      color: #b8bec5;
      line-height: 2rem;
    }

    .ant-pagination-item-link {
      border-radius: 4px;
    }
    .anticon {
      vertical-align: text-top;
    }
  }
`;
